import { createAction, props } from '@ngrx/store';
export const setSelectedReport = createAction('[Custom PDF Report Modal] Set Selected Report', props());
export const setReportTitle = createAction('[Custom PDF Report Modal] Set Report Title', props());
export const resetSelectedReport = createAction('[Custom PDF Report Modal] Reset Selected Report');
export const updateSelectedReportWizardStep = createAction('[Custom PDF Report Modal] Update Wizard Item', props());
